
export const kaTranslations = {
  // Georgian translations
  'nav.home': 'მთავარი',
  'nav.findPlaces': 'ადგილების ძიება',
  'nav.findPlacesShort': 'ძიება',
  'nav.ratePlace': 'ადგილის შეფასება',
  'nav.ratePlaceShort': 'შეფასება',
  'nav.ratePlaces': 'ადგილების შეფასება',
  'nav.login': 'შესვლა',
  'nav.signup': 'რეგისტრაცია',
  'nav.logout': 'გასვლა',
  'nav.profile': 'პროფილი',
  'nav.admin': 'ადმინი',
  'nav.menu': 'მენიუ',
  'nav.account': 'ანგარიში',
  'nav.favorites': 'თქვენი ფავორიტები',
  'favorites.description': 'ფავორიტებში შენახული ბიზნესები',
  // Buttons
  'buttons.loadMore': 'მეტის ჩატვირთვა',
  // Pagination
  'pagination.previous': 'წინა',
  'pagination.next': 'შემდეგი',
  'pagination.goTo': 'გადასვლა:',
  'pagination.go': 'გადასვლა',
  'pagination.of': 'დან',
  'hero.title': 'იპოვე საუკეთესო — აიცილე უარესი!',
  'hero.subtitle': 'ხმა მიეცი ან აღმოაჩინე სასურველი კვების ობიექტები, სპორტ დარბაზები, გასართობი ცენტრები და ბევრი სხვა, მომხმარებელთა რეალურ გამოცდილებაზე დაყრდნობით!',
  'cta.findPlaces': 'ადგილების ძიება',
  'cta.ratePlace': 'ადგილის შეფასება',
  'howItWorks.title': 'როგორ მუშაობს',
  'howItWorks.step1': 'მოძებნე ბიზნესი',
  'howItWorks.step2': 'იხილე დადებითი და უარყოფითი ხმები',
  'howItWorks.step3': 'დატოვე შენი ხმა',
  'featured.title': 'რჩეული ადგილები',
  // Maintenance page
  'maintenance.title': 'საიტზე მიმდინარეობს ტექნიკური სამუშაოები',
  'maintenance.defaultMain': 'ამჟამად ვატარებთ გაუმჯობესებებს და მალე დავბრუნდებით!',
  'maintenance.thankYou': 'გმადლობთ მოთმინებისთვის',
  // Filter translations
  'filters.categories': 'კატეგორია',
  'filters.cities': 'ქალაქი',
  'filters.selected': 'არჩეული',
  // Business card translations
  'businessCard.address': '{0}',
  'businessCard.hours': '{0}',
  'businessCard.phone': '{0}',
  'businessCard.full': 'სრულად',
  'whyTrustUs.title': 'რატომ უნდა გვენდოთ',
  'whyTrustUs.community': '100%-ით საზოგადოების მონაწილეობით',
  'whyTrustUs.realVotes': 'არანაირი სიყალბე, მხოლოდ ნამდვილი ხმები',
  'signup.title': 'შექმენით ანგარიში',
  'signup.button': 'შემოუერთდით ახლავე',
  'footer.quickLinks': 'სწრაფი ბმულები',
  'footer.information': 'ინფორმაცია',
  'footer.about': 'ჩვენს შესახებ',
  'footer.contact': 'კონტაქტი',
  'footer.reachOut': 'დაკავშირება',
  'buttons.viewDetails': 'დეტალების ნახვა',
  'buttons.viewAll': 'ყველას ნახვა',
  'buttons.refresh': 'განახლება',
  'buttons.viewAllPlaces': 'ყველა ადგილის ნახვა',
  'footer.terms': 'მომსახურების პირობები',
  'footer.privacy': 'კონფიდენციალურობის პოლიტიკა',
  'footer.rights': 'ყველა უფლება დაცულია',
  'footer.socialNetworks': 'სოციალური ქსელები',
  
  // Profile page translations
  'profile.title': 'პროფილი',
  
  // Auth translations
  'auth.signIn': 'შესვლა',
  'auth.signUp': 'რეგისტრაცია',
  'auth.signInWithGoogle': 'Google-ით შესვლა',
  'auth.email': 'ელ-ფოსტა',
  'auth.password': 'პაროლი',
  'auth.error': 'შეცდომა',
  'auth.success': 'წარმატება',
  'auth.fillAllFields': 'გთხოვთ შეავსოთ ყველა ველი',
  'auth.accountCreated': 'ანგარიში წარმატებით შეიქმნა! შეამოწმეთ ელ-ფოსტა დასადასტურებლად.',
  'auth.loggedIn': 'წარმატებით შეხვედით სისტემაში!',
  'auth.failed': 'ავთენტიფიკაცია ვერ მოხერხდა',
  'auth.processing': 'მუშავდება...',
  'auth.noAccount': 'არ გაქვთ ანგარიში?',
  'auth.haveAccount': 'უკვე გაქვთ ანგარიში?',
  'auth.loginDescription': 'შეიყვანეთ თქვენი მონაცემები ანგარიშზე წვდომისთვის',
  'auth.signupDescription': 'შექმენით ახალი ანგარიში ჩვენს საზოგადოებაში შესაერთებლად',
  'auth.forgotPassword': 'დაგავიწყდათ პაროლი?',
  'auth.resetPassword': 'პაროლის აღდგენა',
  'auth.enterEmailForReset': 'შეიყვანეთ თქვენი ელ-ფოსტის მისამართი და ჩვენ გამოგიგზავნით პაროლის აღსადგენ ბმულს.',
  'auth.emailRequired': 'ელ-ფოსტა სავალდებულოა',
  'auth.emailNotRegistered': 'ეს ელ-ფოსტა არ არის დარეგისტრირებული. გამოიყენეთ ელ-ფოსტა, რომელზეც დარეგისტრირდით.',
  'auth.resetEmailSent': 'პაროლის აღდგენის ელ-ფოსტა გაიგზავნა! შეამოწმეთ ელ-ფოსტის ყუთი.',
  'auth.emailSent': 'ელ-ფოსტა გაიგზავნა!',
  'auth.checkEmailInbox': 'გთხოვთ შეამოწმოთ ელ-ფოსტის ყუთი და მიჰყევით ინსტრუქციებს პაროლის აღსადგენად.',
  'auth.close': 'დახურვა',
  'auth.sending': 'იგზავნება...',
  'auth.signingIn': 'შედის...',
  'auth.signingUp': 'რეგისტრირდება...',
  'auth.emailPlaceholder': 'თქვენი@ელფოსტა.com',
  'auth.firstNameRequired': 'სახელი სავალდებულოა',
  'auth.lastNameRequired': 'გვარი სავალდებულოა',
  'auth.firstName': 'სახელი',
  'auth.lastName': 'გვარი',
  'auth.continueWith': 'ან განაგრძეთ',
  'auth.passwordMinLength': 'უნდა იყოს მინიმუმ 6 სიმბოლო',
  'auth.passwordHint': 'უნდა იყოს მინიმუმ 8 სიმბოლო',
  'auth.signUpAgreement': 'რეგისტრაციით თქვენ ეთანხმებით ჩვენს მომსახურების პირობებსა და კონფიდენციალურობის პოლიტიკას.',
  'auth.signInAgreement': 'შესვლით თქვენ აღიარებთ, რომ წაიკითხეთ და ეთანხმებით ჩვენს მომსახურების პირობებსა და კონფიდენციალურობის პოლიტიკას.',
  // Search translations
  'search.placeholder': 'ადგილის ძიება...',
  'search.submit': 'ძიება',
  'search.byBusinessName': 'ბიზნესის სახელით ძიება...',
  'search.businessesFound': 'ნაპოვნია {0} ბიზნესი',
  'search.showingOf': '(ნაჩვენებია {0} {1}-დან)',
  'search.showingBusinesses': 'ნაჩვენებია {0} ბიზნესი {1}-დან',
  'search.loadingBusinesses': 'ბიზნესები იტვირთება...',
  'search.searchingBusinesses': 'იძებნება ბიზნესები...',
  'search.loadingMoreBusinesses': 'მეტი ბიზნესის ჩატვირთვა...',
  'search.nextBusinesses': 'შემდეგი 50 ბიზნესი',
  // Business list messages
  'businesses.noResults': 'არჩეული ფილტრების შესაბამისი ბიზნესი ვერ მოიძებნა.',
  'businesses.loadError': 'ბიზნესების ჩატვირთვა ვერ ხერხდება. გთხოვთ სცადოთ გვერდის განახლება.',
  // Business fetch errors
  'businesses.fetchError': 'ბიზნესების ჩატვირთვა ვერ მოხერხდა. სცადეთ ხელახლა.',
  // Rating categories translations
  'rating.service': 'სერვისი',
  'rating.cleanliness': 'სისუფთავე',
  'rating.pricing': 'ფასები',
  'rating.interior': 'ინტერიერი',
  // Business page translations
  'business.information': 'ბიზნესის ინფორმაცია',
  'business.reviews': 'მიმოხილვები',
  'business.ratingsTitle': 'შეფასებები',
  'business.overallRating': 'საერთო შეფასება',
  'business.ratingCategories': 'შეფასების კატეგორიები',
  'business.website': 'ვებსაიტი',
  'business.googleMaps': 'Google Maps-ზე ნახვა',
  'business.placeOrder': 'შეკვეთის განთავსება',
  'business.chooseDeliveryService': 'მიტანის სერვისის არჩევა',
  'business.performanceComparison': 'შედარებითი ანალიზი',
  'business.compareWith': 'შეადარეთ ეს ბიზნესი ყველა {0}-ს საშუალო რეიტინგს {1}-ში',
  'business.basedOnBusinesses': '{0} ბიზნესის საფუძველზე',
  'business.pricingNote': 'შენიშვნა ფასების შესახებ',
  'business.pricingExplanation': 'ვარსკვლავების უფრო მაღალი რეიტინგი მიუთითებს უკეთეს ღირებულებასა და ხელმისაწვდომობაზე',
  'business.cityAverage': 'ქალაქის საშუალო',
  'business.thisBusiness': 'ეს ბიზნესი',
  // Weekdays
  'weekdays.monday': 'ორშაბათი',
  'weekdays.tuesday': 'სამშაბათი',
  'weekdays.wednesday': 'ოთხშაბათი',
  'weekdays.thursday': 'ხუთშაბათი',
  'weekdays.friday': 'პარასკევი',
  'weekdays.saturday': 'შაბათი',
  'weekdays.sunday': 'კვირა',
  // Reviews translations
  'reviews.title': 'მიმოხილვები',
  'reviews.yourReviews': 'თქვენი მიმოხილვები',
  'reviews.googleReviews': 'Google მიმოხილვები',
  'reviews.noReviews': 'ჯერ არ არის მიმოხილვები',
  'reviews.showAll': 'ყველა მიმოხილვის ნახვა',
  'reviews.writePlaceholder': 'მიმოხილვის დაწერა...',
  'reviews.submit': 'მიმოხილვის გაგზავნა',
  'reviews.count.one': 'მიმოხილვა',
  'reviews.count.many': 'მიმოხილვები',
  'reviews.viewMore': 'მეტის ნახვა',
  'reviews.viewLess': 'ნაკლების ნახვა',
  // Activity tab translations
  'profile.upvotes': 'მოწონებები',
  'profile.downvotes': 'დაწუნებები',
  'profile.activity.categoryLabel': 'კატეგორია:',
  // Loading messages
  'loading.default': 'იტვირთება',
  'loading.favorites': 'იტვირთება ფავორიტები',
  'loading.profile': 'იტვირთება პროფილი',
  // Month abbreviations
  'months.jan': 'იან',
  'months.feb': 'თებ',
  'months.mar': 'მარ',
  'months.apr': 'აპრ',
  'months.may': 'მაი',
  'months.jun': 'ივნ',
  'months.jul': 'ივლ',
  'months.aug': 'აგვ',
  'months.sep': 'სექ',
  'months.oct': 'ოქტ',
  'months.nov': 'ნოე',
  'months.dec': 'დეკ',
  // Rating popup translations
  'rating.rateThisBusiness': 'შეაფასეთ ეს ბიზნესი',
  'rating.guestNotice': 'შეგიძლიათ შეფასება სტუმრად, მაგრამ შესვლა გვეხმარება სპამის თავიდან აცილებაში',
  'rating.doneRating': 'შეფასება დასრულებულია',
  'rating.submitError': 'შეფასების გაგზავნა ვერ მოხერხდა',
  'rating.selectCategory': 'გთხოვთ შეაფასოთ მინიმუმ ერთი კატეგორია',
  'rating.thankYou': 'მადლობთ თქვენი შეფასებებისთვის!',
  'rating.yourRating': 'თქვენი შეფასება',
  'rating.clickToRate': 'შეფასებისთვის დააწკაპუნეთ',
  // Category translations for filters
  'categories.all': 'ყველა კატეგორია',
  'categories.restaurant': 'რესტორანი',
  'categories.cafe': 'კაფე',
  'categories.bar': 'ბარი',
  'categories.hotel': 'სასტუმრო',
  'categories.shopping': 'საყიდლები',
  'categories.generalShopping': 'შერეული მაღაზია',
  'categories.generalstore': 'შერეული მაღაზია',
  'categories.entertainment': 'გასართობი',
  'categories.health': 'ჯანმრთელობა',
  'categories.beauty': 'სილამაზე',
  'categories.education': 'განათლება',
  'categories.transport': 'ტრანსპორტი',
  'categories.fastFood': 'სწრაფი კვება',
  'categories.gym': 'სპორტული დარბაზი',
  'categories.pub': 'პაბი',
  'categories.electronicsStore': 'ელექტრონიკა',
  'categories.wellnessCenter': 'გამაჯანსაღებელი ცენტრი',
  'categories.shoppingMall': 'სავაჭრო ცენტრი',
  'categories.movieTheater': 'კინოთეატრი',
  'categories.hamburgerRestaurant': 'საბურგერე',
  'categories.theater': 'თეატრი',
  'categories.puppetTheater': 'თოჯინების თეატრი',
  'categories.museum': 'მუზეუმი',
  'categories.confectioneryShop': 'საკონდიტრო',
  'categories.shawarmaRestaurant': 'საშაურმე',
  'categories.swimmingPool': 'საცურაო აუზი',
  'categories.bakery': 'საცხობი',
  'categories.supermarket': 'სუპერმარკეტი და ჰიპერმარკეტი',
  'categories.supermarketandhypermarket': 'სუპერმარკეტი და ჰიპერმარკეტი',
  'categories.iceCream': 'სანაყინე',
  'categories.coffeeShop': 'ყავის მაღაზია',
  'categories.sportsComplex': 'სპორტული კომპლექსი',
  'categories.clothingStore': 'ტანსაცმელი',
  'categories.giftShop': 'საჩუქრები',
  'categories.toyStore': 'სათამაშოები',
  'categories.market': 'ბაზარი',
  'categories.park': 'პარკი/ბაღი',
  'categories.touristAttraction': 'ღირსშესანიშნაობა',
  'categories.winery': 'მეღვინეობა',
  'categories.library': 'ბიბლიოთეკა',
  'categories.pizza': 'პიცერია',
  'categories.homeGoodsStore': 'სახლისთვის',
  'categories.buildingMaterialsStore': 'სამშენებლო',
  'categories.automobile': 'ავტომობილი',
  'categories.parfumeandcosmetics': 'პარფიუმერია და კოსმეტიკა',
  'categories.jewelryandaccessories': 'სამკაულები და აქსესუარები',
  'categories.bookandstationery': 'წიგნები და საკანცელარიო',
  'categories.alcoholandbeverages': 'ალკოჰოლი და სასმელები',
  'categories.furnitureandtextiles': 'ავეჯი და ტექსტილი',
  'categories.lighting': 'განათება',
  // Lowercase category keys for radar chart
  'categories.hamburgerrestaurant': 'საბურგერე',
  'categories.fastfood': 'სწრაფი კვება',
  'categories.icecream': 'სანაყინე',
  'categories.coffeeshop': 'ყავის მაღაზია',
  'categories.electronicsstore': 'ელექტრონიკა',
  'categories.wellnesscenter': 'გამაჯანსაღებელი ცენტრი',
  'categories.shoppingmall': 'სავაჭრო ცენტრი',
  'categories.movietheater': 'კინოთეატრი',
  'categories.confectioneryshop': 'საკონდიტრო',
  'categories.shawarmarestaurant': 'საშაურმე',
  'categories.swimmingpool': 'საცურაო აუზი',
  'categories.sportscomplex': 'სპორტული კომპლექსი',
  'categories.clothingstore': 'ტანსაცმელი',
  'categories.giftshop': 'საჩუქრები',
  'categories.toystore': 'სათამაშოები',
  'categories.touristattraction': 'ღირსშესანიშნაობა',
  'categories.homegoodsstore': 'სახლისთვის',
  'categories.buildingmaterialsstore': 'სამშენებლო',
  'categories.puppettheater': 'თოჯინების თეატრი',
  // City translations for filters
  'cities.tbilisi': 'თბილისი',
  'cities.batumi': 'ბათუმი',
  'cities.kutaisi': 'ქუთაისი',
  'cities.rustavi': 'რუსთავი',
  'cities.gori': 'გორი',
  'cities.zugdidi': 'ზუგდიდი',
  'cities.poti': 'ფოთი',
  'cities.telavi': 'თელავი',
  'cities.mtskheta': 'მცხეთა',
  'cities.borjomi': 'ბორჯომი',
  'cities.kobuleti': 'ქობულეთი',
  'cities.akhaltsikhe': 'ახალციხე',
  'cities.sachkhere': 'საჩხერე',
  'cities.samtredia': 'სამტრედია',
  'cities.senaki': 'სენაკი',
  'cities.khashuri': 'ხაშური',
  'cities.chiatura': 'ჭიათურა',
  'cities.kvariati': 'კვარიათი',
  'cities.baghdati': 'ბაღდათი',
  'cities.sairme': 'საირმე',
  'cities.kaspi': 'კასპი',
  'cities.tsalka': 'წალკა',
  'cities.tsalenjikha': 'წალენჯიხა',
  'cities.tskaltubo': 'წყალტუბო',
  'cities.khoni': 'ხონი',
  'cities.martvili': 'მარტვილი',
  'cities.vani': 'ვანი',
  'cities.kareli': 'ქარელი',
  'cities.marneuli': 'მარნეული',
  'cities.lanchkhuti': 'ლანჩხუთი',
  'cities.shekvetili': 'შეკვეთილი',
  'cities.chkhorotsku': 'ჩხოროწყუ',
  'cities.ureki': 'ურეკი',
  'cities.gonio': 'გონიო',
  'cities.anaklia': 'ანაკლია',
  'cities.ushguli': 'უშგული',
  'cities.lentekhi': 'ლენტეხი',
  'cities.tsageri': 'ცაგერი',
  'cities.akhalkalaki': 'ახალქალაქი',
  'cities.dusheti': 'დუშეთი',
  'cities.saguramo': 'საგურამო',
  'cities.tianeti': 'თიანეთი',
  'cities.akhmeta': 'ახმეტა',
  'cities.sagarejo': 'საგარეჯო',
  'cities.sighnaghi': 'სიღნაღი',
  'cities.kvareli': 'კვარელი',
  'cities.gurjaani': 'გურჯაანი',
  'cities.lagodekhi': 'ლაგოდეხი',
  'cities.dedoplistskaro': 'დედოფლისწყარო',
  'cities.ninotsminda': 'ნინოწმინდა',
  'cities.dmanisi': 'დმანისი',
  'cities.bolnisi': 'ბოლნისი',
  'cities.gardabani': 'გარდაბანი',
  'cities.abasha': 'აბაშა',
  'cities.tkibuli': 'ტყიბული',
  'cities.bakhmaro': 'ბახმარო',
  'cities.chokhatauri': 'ჩოხატაური',
  'cities.shuakhevi': 'შუახევი',
  'cities.keda': 'ქედა',
  'cities.khulo': 'ხულო',
  'cities.manglisi': 'მანგლისი',
  // Missing Georgian translations for cities
  'cities.bakuriani': 'ბაკურიანი',
  'cities.gudauri': 'გუდაური',
  'cities.mestia': 'მესტია',
  'cities.oni': 'ონი',
  'cities.ozurgeti': 'ოზურგეთი',
  'cities.stepantsminda': 'სტეფანწმინდა',
  'cities.terjola': 'თერჯოლა',
  'cities.zestafoni': 'ზესტაფონი',
  'cities.ambrolauri': 'ამბროლაური',
  'cities.natakhtari': 'ნატახტარი',
  // Review translations - additional
  'reviews.pleaseEnterReview': 'გთხოვთ შეიყვანოთ მიმოხილვა',
  'reviews.invalidReview': 'არასწორი მიმოხილვა',
  'reviews.onlyBadWordsError': 'მიმოხილვა არ შეიძლება შეიცავდეს მხოლოდ არაშესაფერის კონტენტს',
  'reviews.spamContentError': 'თქვენი მიმოხილვა შეიცავს სარეკლამო ან სპამ კონტენტს და ვერ გაიგზავნება.',
  'reviews.pleaseWait': 'გთხოვთ დაელოდოთ',
  'reviews.rateLimitError': 'შეგიძლიათ ახალი მიმოხილვა გაგზავნოთ 30 წამის შემდეგ',
  'reviews.mustBeLoggedIn': 'მიმოხილვის გასაგზავნად უნდა იყოთ სისტემაში შესული',
  'reviews.duplicateReview': 'დუბლირებული მიმოხილვა',
  'reviews.duplicateReviewBody': 'თქვენ უკვე გაქვთ მიმოხილვა ამ ბიზნესზე.',
  'reviews.somethingWentWrong': 'რაღაც არასწორად წავიდა.',
  'reviews.submitFailedTryAgain': 'მიმოხილვის გაგზავნა ვერ მოხერხდა, სცადეთ ხელახლა.',
  'reviews.reviewSubmitted': 'თქვენი მიმოხილვა გაიგზავნა',
  'reviews.submitFailed': 'მიმოხილვის გაგზავნა ვერ მოხერხდა',
  'reviews.spamWarning': 'თქვენი მიმოხილვა შეიცავს ბმულს ან სარეკლამო კონტენტს.',
  'reviews.badWordsOnlyWarning': 'მიმოხილვა არ შეიძლება შეიცავდეს მხოლოდ არაშესაფერის სიტყვებს.',
  // Profile page translations
  'profile.accountInformation': 'ანგარიშის ინფორმაცია',
  'profile.email': 'ელ-ფოსტა',
  'profile.firstName': 'სახელი',
  'profile.lastName': 'გვარი',
  'profile.saveChanges': 'ცვლილებების შენახვა',
  'profile.saving': 'ინახება...',
  'profile.validation.nameRequired': 'სახელი ან გვარი უნდა შეიცავდეს მინიმუმ 3 ასოს',
  'profile.validation.nameTaken': 'ეს სახელი ან გვარი უკვე გამოყენებულია. გთხოვთ აირჩიოთ სხვა.',
  'profile.validation.nameReserved': 'ეს სახელი ან გვარი დაცულია და არ შეიძლება გამოიყენოთ.',
  'profile.validation.nameBadWord': 'სახელი ან გვარი შეიცავს არაშესაფერის სიტყვებს.',
  'profile.updateSuccess': 'პროფილი განახლებულია',
  'profile.updateSuccessDescription': 'თქვენი პროფილი წარმატებით განახლდა.',
  'profile.updateError': 'შეცდომა',
  'profile.updateErrorDescription': 'პროფილის განახლება ვერ მოხერხდა. სცადეთ ხელახლა.',
  'profile.accountActions': 'ანგარიშის მოქმედებები',
  'profile.signOutDescription': 'თქვენი ანგარიშიდან გამოსვლა',
  'profile.signOut': 'გასვლა',
  'profile.yourActivity': 'თქვენი აქტივობა',
  'profile.activityDescription': 'თქვენი ბოლო აქტივობები და ინტერაქციები',
  'profile.adminTools': 'ადმინისტრატორის ხელსაწყოები',
  'profile.updateAdminProfiles': 'ადმინ პროფილების განახლება',
  'reviews.characterLimitReached': 'მაქსიმალური სიმბოლოების რაოდენობა მიღწეულია',
  'reviews.submitting': 'იგზავნება...',
  // Page content translations
  'pages.about.title': 'ჩვენ შესახებ',
  'pages.about.welcome': 'კეთილი იყოს თქვენი მობრძანება GoodVote.ge-ზე – თქვენს რაიონში საუკეთესო ბიზნესის აღმოჩენის, გამოკვლევისა და შეფასების პლატფორმა.',
  'pages.about.belief': 'GoodVote-ზე ჩვენ ვიცით, რომ ადგილობრივი ცოდნა ძლიერია. იძებთ თუ არა მყუდრო კაფეს, რომანტიულ რესტორანს თუ თქვენს ქალაქში დამალულ პერლს, ჩვენი პლატფორმა გეხმარებათ დარწმუნებული გადაწყვეტილებები მიიღოთ.',
  'pages.about.description': 'ჩვენ Google-ის ბიზნეს მონაცემთა API-ს ვიყენებთ ბიზნესებზე განახლებული ინფორმაციის მისაწოდებლად და შემდეგ თქვენ, საზოგადოებას, ვაძლევთ ხმის მიცემის, შეფასების და რეკომენდაციის საშუალებას.',
  'pages.about.independence': 'GoodVote დამოუკიდებელი და უფასო გამოსაყენებელია, სიმარტივის გათვალისწინებით აშენებული. ჩვენ არ ვიღებთ ფასს წვდომისთვის და არ ვარტულებთ თქვენს გამოცდილებას გადახდებით.',
  'pages.about.why.title': 'რატომ ვარსებობთ:',
  'pages.about.why.point1': 'მომხმარებლების გაძლიერება ადგილობრივი სერვისების შესახებ უკეთესი არჩევანის გასაკეთებლად.',
  'pages.about.why.point2': 'ადგილობრივი ბიზნესის მხარდაჭერა ხარისხისა და გამჭვირვალობის ხაზგასმით.',
  'pages.about.why.point3': 'ხმაურისა და მიკერძოებულობის გარეშე მიმოხილვების საიმედო სივრცის შექმნა.',
  'pages.about.companion': 'ახალ ქალაქში მოგზავრე ხართ თუ ადგილობრივი, რომელიც თქვენს უბანს იკვლევს, GoodVote.ge თქვენი ციფრული კომპანიონია.',
  'pages.contact.title': 'დაკავშირება',
  'pages.contact.description': 'გაქვთ კითხვები, წინადადებები ან გსურთ დაკავშირება? სიამოვნებით მოგისმენთ.',
  'pages.contact.button': 'კონტაქტი',
  'pages.contact.emailLabel': 'ჩვენი ელ-ფოსტის მისამართი:',
  // Terms of Service translations
  'pages.terms.title': 'GoodVote.ge-ის მომსახურების პირობები',
  'pages.terms.effective': 'ძალაში შესვლის თარიღი: 19 ივლისი, 2025',
  'pages.terms.welcome': 'კეთილი იყოს თქვენი მობრძანება GoodVote.ge-ზე! ჩვენი ვებსაიტის გამოყენებით თქვენ ეთანხმებით შემდეგ მომსახურების პირობებს. გთხოვთ ყურადღებით წაიკითხოთ.',
  'pages.terms.use.title': '1. ჩვენი სერვისის გამოყენება',
  'pages.terms.use.description': 'GoodVote.ge არის პლატფორმა ადგილობრივი ბიზნესების აღმოჩენისა და შეფასებისთვის.',
  'pages.terms.use.point1': 'ჩვენ ვიყენებთ Google-ისა და სხვა წყაროების საჯარო API-ებს ბიზნეს მონაცემების მოსაპოვებლად და ჩვენებისთვის. ჩვენ არ ვიპყრობთ ამ მონაცემების საკუთრებას.',
  'pages.terms.use.point2': 'თქვენ არ შეგიძლიათ გამოიყენოთ ვებსაიტი უკანონო, მავნე ან შეურაცხმყოფელი მიზნებისთვის.',
  'pages.terms.use.point3': 'თქვენ არ უნდა ცადოთ ჩვენი სერვისების გატეხვა, მონაცემების მოპარვა ან საწინააღმდეგო ინჟინერია.',
  'pages.terms.content.title': '2. მომხმარებლის მიერ შექმნილი კონტენტი',
  'pages.terms.content.point1': 'მომხმარებლებს შეუძლიათ წარადგინონ მიმოხილვები, ხმები და უკუკავშირი ბიზნესების შესახებ.',
  'pages.terms.content.point2': 'თქვენ პასუხისმგებელი ხართ თქვენს მიერ გამოქვეყნებულ კონტენტზე.',
  'pages.terms.content.point3': 'ჩვენ შეგვიძლია წავშალოთ კონტენტი, რომელიც შეურაცხმყოფელია, შეცდომაშია ან არღვევს კანონებს ან ჩვენს საზოგადოების სტანდარტებს.',
  'pages.terms.account.title': '3. ანგარიშის მართვა და შესვლა',
  'pages.terms.account.point1': 'ზოგიერთი ფუნქცია, როგორიცაა მიმოხილვების წარდგენა ან ფავორიტების შენახვა, შეიძლება მოითხოვდეს შესვლას.',
  'pages.terms.account.point2': 'თქვენ პასუხისმგებელი ხართ თქვენი ანგარიშის უსაფრთხოებასა და ნებისმიერ ქმედებაზე, რომელიც ხდება თქვენს ანგარიშში.',
  'pages.terms.account.point3': 'თუ აირჩევთ Google-ით რეგისტრაციას ან შესვლას, თქვენ ეთანხმებით, რომ ნების დართოთ თქვენი Google პროფილის ინფორმაციის (სახელი და ელ-ფოსტა) გამოყენება ანგარიშის შესაქმნელად და სამართავად.',
  'pages.terms.account.point4': 'თქვენ არ უნდა გაუზიაროთ თქვენი შესვლის მონაცემები ან სხვის ნაცვლად იმოქმედოთ.',
  'pages.terms.ip.title': '4. ინტელექტუალური საკუთრება',
  'pages.terms.ip.point1': 'ყველა ვებსაიტის კოდი, დიზაინი და ორიგინალური კონტენტი ეკუთვნის GoodVote.ge-ს, თუ სხვაგვარად არ არის მითითებული.',
  'pages.terms.ip.point2': 'Google-ის ბიზნეს მონაცემები, ლოგოები და სხვა მესამე მხარის სავაჭრო ნიშნები ეკუთვნის მათ შესაბამის მფლობელებს.',
  'pages.terms.thirdparty.title': '5. მესამე მხარის სერვისები',
  'pages.terms.thirdparty.point1': 'ჩვენ ვიყენებთ მესამე მხარის სერვისებს ჩვენი ვებსაიტის მუშაობისთვის, მათ შორის Supabase-ს ჩვენი ბექენდისა და მომხმარებლის ავთენტიფიკაციისთვის და Google API-ებს ბიზნეს ინფორმაციის საჩვენებლად.',
  'pages.terms.thirdparty.point2': 'ჩვენ პასუხი არ ვაგებთ ამ მესამე მხარის სერვისების მონაცემების სიზუსტეზე ან მთლიანობაზე.',
  'pages.terms.thirdparty.point3': 'თქვენი ჩვენი სერვისის გამოყენება ასევე ექვემდებარება ჩვენი მესამე მხარის მომწოდებლების მომსახურების პირობებს.',
  'pages.terms.liability.title': '6. პასუხისმგებლობის შეზღუდვა',
  'pages.terms.liability.point1': 'ჩვენ პასუხი არ ვაგებთ ნებისმიერ ზიანზე, რომელიც გამოწვეული იქნება საიტის გამოყენებით.',
  'pages.terms.liability.point2': 'სერვისი მიწოდებულია "როგორც არის" ყოველგვარი გარანტიების გარეშე.',
  'pages.terms.changes.title': '7. პირობების ცვლილებები',
  'pages.terms.changes.point1': 'ეს მომსახურების პირობები შეიძლება პერიოდულად განახლდეს. ჩვენ შეგატყობინებთ მნიშვნელოვან ცვლილებებზე ამ გვერდზე ახალი პირობების გამოქვეყნებით.',
  'pages.terms.changes.point2': 'საიტის მუდმივი გამოყენება ნებისმიერი ცვლილების შემდეგ ნიშნავს, რომ თქვენ იღებთ განახლებულ პირობებს.',
  'pages.terms.termination.title': '8. შეწყვეტა',
  'pages.terms.termination.description': 'ჩვენ ვიტოვებთ უფლებას შევჩერდეთ ან შევწყვიტოთ თქვენი ანგარიში და სერვისზე წვდომა ჩვენი ერთპიროვნული გადაწყვეტილებით, შეტყობინების გარეშე, ნებისმიერი ქცევისთვის, რომელიც ჩვენი აზრით არღვევს ამ მომსახურების პირობებს ან მავნეა სხვა მომხმარებლებისთვის ან ჩვენთვის.',
  'pages.terms.contact.title': '9. კონტაქტი',
  'pages.terms.contact.text': 'ამ პირობების შესახებ კითხვებისთვის გამოგვიგზავნეთ ელ-ფოსტა:',
  'pages.privacy.title': 'GoodVote.ge-ის კონფიდენციალურობის პოლიტიკა',
  'pages.privacy.effective': 'ძალაში შესვლის თარიღი: 19 ივლისი, 2025',
  'pages.privacy.welcome': 'კეთილი იყოს თქვენი მობრძანება GoodVote.ge-ზე! ეს კონფიდენციალურობის პოლიტიკა განმარტავს, თუ როგორ ვაგროვებთ, ვიყენებთ და ვიცავთ თქვენს ინფორმაციას ჩვენი ვებსაიტისა და სერვისების გამოყენებისას.',
  'pages.privacy.collect.title': '1. ინფორმაცია, რასაც ვაგროვებთ',
  'pages.privacy.collect.intro': 'ჩვენ შეგვიძლია ავაგროვოთ:',
  'pages.privacy.collect.point1': 'თქვენი სახელი და ელ-ფოსტა (თუ ანგარიშს შექმნით ან დაგვიკავშირდებით).',
  'pages.privacy.collect.point2': 'IP მისამართი, ბრაუზერის ტიპი, მოწყობილობის ინფორმაცია (ავტომატურად cookies-ით ან ლოგებით).',
  'pages.privacy.collect.point3': 'მიმოხილვები ან ხმები, რომლებსაც წარადგენთ.',
  'pages.privacy.collect.googleTitle': '1.1. Google Sign-In-დან მოპოვებული ინფორმაცია',
  'pages.privacy.collect.googleDescription': 'თუ აირჩევთ Google ანგარიშით რეგისტრაციას ან შესვლას, თქვენ გვაძლევთ ნებართვას თქვენი Google პროფილის განსაზღვრული ინფორმაციის მოპოვებაზე.',
  'pages.privacy.collect.googleName': 'თქვენი სახელი:',
  'pages.privacy.collect.googleNameDescription': '...auth/userinfo.profile scope-დან ვაგროვებთ თქვენს სახელსა და გვარს.',
  'pages.privacy.collect.googleEmail': 'თქვენი ელ-ფოსტის მისამართი:',
  'pages.privacy.collect.googleEmailDescription': '...auth/userinfo.email scope-დან ვაგროვებთ თქვენს მთავარ ელ-ფოსტის მისამართს.',
  'pages.privacy.collect.googleNote': 'ჩვენ არ ვპოულობთ, არ ვინახავთ და არ ვაზიარებთ თქვენი Google ანგარიშის სხვა ინფორმაციას.',
  'pages.privacy.use.title': '2. როგორ ვიყენებთ თქვენს ინფორმაციას',
  'pages.privacy.use.intro': 'ჩვენ ვიყენებთ თქვენს ინფორმაციას:',
  'pages.privacy.use.point1': 'ჩვენი სერვისების უზრუნველსაყოფად და გასაუმჯობესებლად.',
  'pages.privacy.use.point2': 'თქვენი მიმოხილვებისა და შეფასებების ბიზნეს სიებში საჩვენებლად.',
  'pages.privacy.use.point3': 'შეტყობინებების ან განახლებების გასაგზავნად (თუ ეთანხმეთ).',
  'pages.privacy.use.point4': 'გამოყენების ნიმუშების ანალიზისთვის მომხმარებლის გამოცდილების გაუმჯობესების მიზნით.',
  'pages.privacy.use.point5': 'Google Sign-In-ით შესვლისას თქვენი ანგარიშის შექმნასა და მართვისთვის.',
  'pages.privacy.cookies.title': '3. Cookies და თვალყურის დევნება',
  'pages.privacy.cookies.text': 'ჩვენ ვიყენებთ cookies-ს საიტის ფუნქციონირების გასაუმჯობესებლად და ანალიტიკისთვის.',
  'pages.privacy.thirdparty.title': '4. მესამე მხარის სერვისები',
  'pages.privacy.thirdparty.text': 'ჩვენ შეგვიძლია გამოვიყენოთ მესამე მხარის სერვისები ჩვენი ვებსაიტისა და სერვისების ფუნქციონირებაში დასახმარებლად.',
  'pages.privacy.thirdparty.supabase': 'Supabase:',
  'pages.privacy.thirdparty.supabaseDescription': 'ჩვენ ვიყენებთ Supabase-ს, როგორც ჩვენს ბექენდ სერვის მომწოდებელს.',
  'pages.privacy.thirdparty.analytics': 'Google Analytics:',
  'pages.privacy.thirdparty.analyticsDescription': 'ჩვენ ვიყენებთ Google Analytics-ს ვებსაიტის გამოყენების ანალიზისთვის.',
  'pages.privacy.sharing.title': '5. მონაცემების გაზიარება',
  'pages.privacy.sharing.intro': 'ჩვენ არ ვყიდით თქვენს პირად ინფორმაციას. ჩვენ შეგვიძლია გავუზიაროთ მონაცემები მხოლოდ ამ შემთხვევებში:',
  'pages.privacy.sharing.point1': 'თქვენი თანხმობით.',
  'pages.privacy.sharing.point2': 'იურიდიული შესაბამისობისთვის ან ჩვენი უფლებების დასაცავად.',
  'pages.privacy.sharing.point3': 'მესამე მხარის მომსახურების მომწოდებლებთან, რომლებიც გვეხმარებიან საიტის ექსპლუატაციაში.',
  'pages.privacy.security.title': '6. მონაცემთა უსაფრთხოება',
  'pages.privacy.security.text': 'ჩვენ ვახორციელებთ გონივრულ უსაფრთხოების ზომებს თქვენი მონაცემების დასაცავად, მათ შორის თქვენი ინფორმაციის უსაფრთხო პლატფორმებზე, როგორიცაა Supabase, შენახვას.',
  'pages.privacy.rights.title': '7. თქვენი უფლებები',
  'pages.privacy.rights.description': 'თქვენ გაქვთ უფლება წვდომა, შესწორება ან თქვენი მონაცემების წაშლის მოთხოვნა.',
  'pages.privacy.rights.point1': 'შეგიძლიათ მართოთ თქვენი პროფილის ინფორმაცია ანგარიშის პარამეტრებში.',
  'pages.privacy.rights.point2': 'თქვენი პირადი მონაცემების წვდომის, შესწორების ან წაშლის მოთხოვნისთვის დაგვიკავშირდით contact@goodvote.ge-ზე.',
  'pages.privacy.rights.point3': 'შეგიძლიათ უარი თქვათ cookies-ზე ან ანალიტიკური ტრეკინგის თვალყურის დევნებაზე თქვენი ბრაუზერის პარამეტრებით.',
  'pages.privacy.changes.title': '8. ამ პოლიტიკის ცვლილებები',
  'pages.privacy.changes.text': 'ეს კონფიდენციალურობის პოლიტიკა შეიძლება განახლდეს დროდადრო. ჩვენ განახლებებს გამოვაქვეყნებთ ამ გვერდზე ახალი ძალაში შესვლის თარიღით.',
  'pages.privacy.contact.title': '9. კონტაქტი',
  'pages.privacy.contact.text': 'ამ კონფიდენციალურობის პოლიტიკის ან ჩვენი მონაცემთა პრაქტიკის შესახებ რაიმე კითხვისას, გთხოვთ დაგვიკავშირდეთ:',

  // Review reactions
  'reviews.like': 'მომწონს',
  'reviews.dislike': 'არ მომწონს',
  'reviews.signInToReact': 'გთხოვთ შეხვიდეთ რომ მოახდინოთ კომენტარის შეფასება',
  'reviews.reactionError': 'რეაქციის დამატება ვერ მოხერხდა',

  // Badges
  'badges.newbie': 'ახალბედა',
  'badges.explorer': 'მკვლევარი',
  'badges.helper': 'დამხმარე',
  'badges.trustedLocal': 'მცოდნე',
  'badges.localExpert': 'ექსპერტი',
  'badges.cityMaster': 'ქალაქის გული',
  'badges.countryMaster': 'ქვეყნის გული',
  'badges.cleanlinessGuardian': 'სისუფთავის დამცველი',
  'badges.priceScout': 'ფასის მცველი',
  'badges.serviceJudge': 'მასპინძელი',
  'badges.interiorCritic': 'ინტერიერის სპეციალისტი',

  // Badge descriptions
  'badges.desc.newbie': '1-დან 9-მდე შეფასება/კომენტარი',
  'badges.desc.explorer': '10-დან 29-მდე შეფასება/კომენტარი',
  'badges.desc.helper': '30-დან 49-მდე შეფასება/კომენტარი',
  'badges.desc.trustedLocal': '50-დან 99-მდე შეფასება/კომენტარი',
  'badges.desc.localExpert': '100-დან 199-მდე შეფასება/კომენტარი',
  'badges.desc.cityMaster': '200-დან 299-მდე შეფასება/კომენტარი',
  'badges.desc.countryMaster': '300 ან მეტი შეფასება/კომენტარი',
  'badges.desc.cleanlinessGuardian': '50+ სისუფთავის შეფასება',
  'badges.desc.priceScout': '50+ ფასის შეფასება',
  'badges.desc.serviceJudge': '50+ მომსახურების შეფასება',
  'badges.desc.interiorCritic': '50+ ინტერიერის შეფასება',

  // Badge requirements
  'badges.req.newbie': 'დატოვე 1-დან 9-მდე კომენტარი',
  'badges.req.explorer': 'დატოვე 10-დან 29-მდე კომენტარი',
  'badges.req.helper': 'დატოვე 30-დან 49-მდე კომენტარი',
  'badges.req.trustedLocal': 'დატოვე 50-დან 99-მდე კომენტარი',
  'badges.req.localExpert': 'დატოვე 100-დან 199-მდე კომენტარი',
  'badges.req.cityMaster': 'დატოვე 200-დან 299-მდე კომენტარი',
  'badges.req.countryMaster': 'დატოვე 300 ან მეტი კომენტარი',
  'badges.req.cleanlinessGuardian': 'შეაფასე სისუფთავე 50 ან მეტჯერ',
  'badges.req.priceScout': 'შეაფასე ფასი 50 ან მეტჯერ',
  'badges.req.serviceJudge': 'შეაფასე მომსახურება 50 ან მეტჯერ',
  'badges.req.interiorCritic': 'შეაფასე ინტერიერი 50 ან მეტჯერ',

  'badges.title': 'თქვენი ბეიჯები',
  'badges.allBadges': 'ყველა ბეიჯი',
  'badges.infoSheet.title': 'როგორ მოვიპოვო ბეიჯები',
  'badges.progress': 'პროგრესი',
  'badges.earned': 'მოპოვებული',
  'badges.primaryBadges': 'ძირითადი ბეიჯები',
  'badges.specialtyBadges': 'სპეციალური ბეიჯები',
  'badges.selectToDisplay': 'აირჩიეთ ბეიჯი, რომელიც გამოჩნდება კომენტარებში',
  'badges.selectToShow': 'საჩვენებლად აირჩიე',
  'badges.displayBadgeUpdated': 'ბეიჯი წარმატებით განახლდა',
  'badges.displayBadgeUpdatedDesc': 'თქვენი არჩეული ბეიჯი ახლა გამოჩნდება ყველა კომენტარზე',
  'badges.displayBadgeUpdateError': 'ბეიჯის განახლება ვერ მოხერხდა',
  'badges.stats.current': 'მიმდინარე რაოდენობა -',
  'badges.stats.currentReviews': 'მიმდინარე კომენტარები',
  'badges.stats.currentRatings': 'მიმდინარე შეფასებები',
  'badges.stats.currentCleanliness': 'მიმდინარე რაოდენობა -',
  'badges.stats.currentPricing': 'მიმდინარე რაოდენობა -',
  'badges.stats.currentService': 'მიმდინარე რაოდენობა -',
  'badges.stats.currentInterior': 'მიმდინარე რაოდენობა -',
  
  // Earned badges section
  'badges.earnedBadges': 'მოპოვებული ბეიჯები',
  
  // Auth sign out messages
  'auth.signedOutSuccess': 'თქვენ წარმატებით გამოხვედით',
  'auth.signOutError': 'გამოსვლა ვერ მოხერხდა. გთხოვთ სცადოთ თავიდან.',
  
  // Review toast messages
  'reviews.updateSuccess': 'მიმოხილვა წარმატებით განახლდა',
  'reviews.updateError': 'მიმოხილვის განახლება ვერ მოხერხდა',
  'reviews.deleteSuccess': 'მიმოხილვა წარმატებით წაიშალა',
  'reviews.deleteError': 'მიმოხილვის წაშლა ვერ მოხერხდა',
  'reviews.submitSuccess': 'მიმოხილვა წარმატებით გაიგზავნა!',
  
  // Delete confirmation dialog
  'dialog.areYouAbsolutelySure': 'დარწმუნებული ხართ?',
  'dialog.deleteReviewWarning': 'ეს მოქმედება ვერ გაუქმდება. თქვენი მიმოხილვა სამუდამოდ წაიშლება.',
  'dialog.delete': 'წაშლა',
  'dialog.cancel': 'გაუქმება',
  
  // Welcome toast and profile
  'auth.signedInSuccessfully': 'წარმატებით შეხვედით',
  'auth.welcome': 'კეთილი იყოს თქვენი',
  'auth.dismiss': 'დახურვა',
  'profile.characters': 'სიმბოლო',
};
